export default {
    LOAD_CLIENTS(state, clients) {
        state.items = clients;
    }
}